<div class="flex items-center justify-between">
  <div #title>{{widgetHeader()}}</div>
</div>
<div class="flex items-center gap-2 mb-1">
  <p class="text-2xl">{{ data().total }}</p>
  <i *ngIf="data().trend > 0" class="pi pi-arrow-circle-up text-green-500"></i>
  <i *ngIf="data().trend < 0" class="pi pi-arrow-circle-down text-red-500"></i>
</div>

<div class="text-sm">
  <span *ngIf="data().trend > 0" class="text-green-500">+{{data().trend}}</span>
  <span *ngIf="data().trend < 0" class="text-red-500">{{data().trend}}</span>
  <span *ngIf="data().days"> in den letzten {{ data().days }} Tagen </span>
</div>
